import { createAction } from '@reduxjs/toolkit'

import type { FilterItem } from '.'

export const changeFilterItems = (sliceName: string) =>
  createAction<FilterItem[]>(`${sliceName}/changeFilterItems`)

export const addNewFilter = (sliceName: string) =>
  createAction<
    {
      field: string
    } & Partial<FilterItem>
  >(`${sliceName}/addNewFilter`)

export const updateFilter = (sliceName: string) =>
  createAction<FilterItem>(`${sliceName}/updateFilter`)

export const deleteFilter = (sliceName: string) =>
  createAction<FilterItem>(`${sliceName}/deleteFilter`)
